// @ngInject
export function requireBetaFeatures(UsersApiService, $state, $stateParams) {
  return UsersApiService.getSelf().then((user) => {
    if (!user.betaFeatures) {
      return $state.go('variant.overview', $stateParams, {
        location: 'replace',
      });
    }
  });
}
